import qs from 'qs'
import useSWRInfinite from 'swr/infinite'

import { ApiResult, isSuccess } from '@/httpRequest'
import { IGetStoryResponse } from '@/httpRequest/modules/home/discovery'
import { getGroupList } from '@/httpRequest/modules/imInfo/groupList'
import { store } from '@/store'
import { loginStateAtom } from '@/store/user'

const PAGE_SIZE = 20

const useSWRGroupList = () => {
  const getKey = (
    pageIndex: number,
    previousPageData: ApiResult<IGetStoryResponse>
  ) => {
    // 已经到最后一页
    if (previousPageData && !previousPageData.data) return null

    // 在首页时，没有 `previousPageData`
    if (pageIndex === 0)
      return `/imApi/group/listByAdmin?page=1&size=${PAGE_SIZE}`

    // 将游标添加到 API
    return `/imApi/group/listByAdmin?page=${pageIndex + 1}&size=${PAGE_SIZE}`
  }

  const { data, size, setSize, isLoading, mutate } = useSWRInfinite(
    getKey,
    async (url: string) => {
      if (!store.get(loginStateAtom)) {
        return
      }
      const params = qs.parse(url.split('?')[1])
      const resp = await getGroupList(params)
      if (isSuccess(resp)) {
        return resp
      }

      throw new Error(resp?.message)
    }
  )

  return {
    data,
    size,
    mutate,
    setSize,
    isLoading
  }
}

export default useSWRGroupList
